import * as React from "react";
import { forwardRef } from "react";
const SvgCheckradioline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 8, stroke: "current", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgCheckradioline);
export { ForwardRef as ReactComponent };
